import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "./Header";
import Footer from "./Footer";
import config from "../../config";
import Swal from "sweetalert2";

const Manage_product = () => {
  const [products, setProducts] = useState([]);
  let userDetail = localStorage.getItem("ship_rocket_user");
  let userData = userDetail ? JSON.parse(userDetail) : {};

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
        let url = config.apiUrl + "/user/getAllProducts";
        let dataToSend = {customer_id:userData.customer_id}
      const res = await axios.post(url, dataToSend, { headers: config.headers });
      setProducts(res.data.products);
    } catch (error) {
      console.error("Failed to fetch products", error);
    }
  };

  const goToProduct = (product, mode) => {
    window.location.href = `/create_product?mode=${mode}&product_id=${product.product_id}`;
  };

  const handleDelete = async (product_id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This will delete the product permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        let url = config.apiUrl + "/user/deleteProduct";
        let dataToSend = {customer_id:userData.customer_id , product_id:product_id}
        await axios.post(url, dataToSend, { headers: config.headers });
        Swal.fire("Deleted!", "Product has been deleted.", "success");
        fetchProducts();
      } catch (error) {
        console.error("Error deleting product:", error);
        Swal.fire("Error", "Something went wrong.", "error");
      }
    }
  };

  return (
    <div>
      <Header />
      <div className="page-wrapper pinned">
        <div className="main-container">
          <div className="app-container">
            <div className="app-body">
              <div className="container-fluid">

                {/* Mobile Nav */}
                <div className="mob_nav">
                  <div className="d-flex justify-content-start">
                    <a href="javascript:window.history.back();" className=""><i className="bi bi-arrow-left"></i></a>
                    <h2>Manage Products</h2>
                  </div>
                </div>

                {/* Desktop Nav + Create Button */}
                <div className="row justify-content-between">
                  <div className="col-12 col-md-3 desk_nav">
                    <div className="d-flex">
                      <a href="javascript:window.history.back();" className="back_btn"><i className="bi bi-arrow-90deg-left"></i></a>
                      <h2>Manage Products</h2>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 desk_nav">
                    <div className="">
                      <h3 className="text-danger" style={{fontWeight:"bold"}}>Save Products for a Faster booking experience !</h3>
                      <div className="" style={{fontWeight:"bold" , color:"black"}}>No need to enter product details and dimensions every time you create an order !</div>
                    </div>
                  </div>
                  <div className="col-12 col-md-3 mb-3">
                    <div className="row justify-content-end">
                      {/* <div className="col-6 col-md-6"> */}
                        <div className="d-grid">
                          <a href="/create_product" className="btn btn-primary btn-block"><i className="bi bi-plus"></i> Create Product</a>
                        </div>
                      {/* </div> */}
                    </div>
                  </div>
                </div>

                {/* Desktop Table */}
                <div className="card data_table mb-3 mb_display_none">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div className="shipm_tablew rounded-3">
                        <table className="table align-top table-striped table-hover m-0 table-xl">
                          <thead>
                            <tr>
                              <th>Sr No</th>
                              <th>SKU ID</th>
                              <th width="270px">Product Name</th>
                              <th>Price</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {products.map((product, index) => (
                              <tr key={product._id}>
                                <td>{index + 1}</td>
                                <td>{product.sku_id}</td>
                                <td>
                                  <h6>
                                    <a
                                      href="#!"
                                      className="text-primary"
                                      onClick={() => goToProduct(product, "edit")}
                                    >
                                      {product.product_name}
                                    </a>
                                  </h6>
                                </td>
                                <td>{parseFloat(product.price).toFixed(2)}</td>
                                <td>
                                  <div className="btn-group">
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary"
                                      onClick={() => goToProduct(product, "edit")}
                                    >
                                      Edit Product
                                    </button>
                                    <div className="btn-group">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      ></button>
                                      <div className="dropdown-menu">
                                        <a
                                          className="dropdown-item text-danger"
                                          href="#!"
                                          onClick={() => handleDelete(product.product_id)}
                                        >
                                          Delete Product
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))}
                            {products.length === 0 && (
                              <tr>
                                <td colSpan="5" className="text-center">
                                  No products found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mobile View Cards */}
                <section>
                  {products.map((product, index) => (
                    <div className="card desk_display_none mb-3 shipm_tablew" key={product._id}>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-10">
                            <h5>{product.product_name}</h5>
                            <div className="text-muted small">SKU: {product.sku_id}</div>
                          </div>
                          <div className="col-2 text-end">
                            <button
                              className="btn btn-outline-secondary btn-sm"
                              data-bs-toggle="collapse"
                              data-bs-target={`#product_${index}`}
                            >
                              <i className="bi bi-caret-down"></i>
                            </button>
                          </div>
                          <div className="col-12 text-center mt-2">
                            <span className="badge bg-info text-dark">₹ {product.price}</span>
                          </div>

                          <div className="collapse" id={`product_${index}`}>
                            <hr />
                            <div className="col-12 mb-2 text-center">
                              <img
                                src={product.image_url || "https://via.placeholder.com/150"}
                                alt={product.product_name}
                                className="img-fluid rounded"
                                style={{ maxHeight: "120px" }}
                              />
                            </div>
                            <div className="col-12 mb-2 text-center">
                              <button
                                className="btn btn-outline-primary btn-sm me-2"
                                onClick={() => goToProduct(product, "edit")}
                              >
                                View
                              </button>
                              <button
                                className="btn btn-outline-secondary btn-sm me-2"
                                onClick={() => goToProduct(product, "edit")}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => handleDelete(product.product_id)}
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </section>

              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Manage_product;
